import produce from "immer";

import { Application as BaseApplication } from "../../api/application";

interface Application extends BaseApplication {
  statusDescription: string;
  typeDescription: string;
}

interface State {
  loading: boolean;
  applications: Application[] | null;
  error: string | null;
}

export const initialState: State = {
  loading: false,
  applications: null,
  error: null,
};

type Action =
  | { type: "FETCH_DATA" }
  | {
      type: "FETCH_SUCCESS";
      payload: { data: { applications: BaseApplication[]; dictionary: Record<string, string> } };
    }
  | { type: "FETCH_ERROR" };

export const applicationOverviewReducer = (state: State, action: Action): State => {
  switch (action.type) {
    case "FETCH_DATA":
      return produce(state, (draft) => {
        draft.loading = true;
        draft.error = null;
      });
    case "FETCH_SUCCESS":
      return produce(state, (draft) => {
        const { applications, dictionary } = action.payload.data;

        draft.loading = false;
        draft.applications = applications.map((application) => ({
          ...application,
          statusDescription: dictionary[application.status] ?? application.status,
          typeDescription: dictionary[application.type] ?? application.type,
        }));
      });
    case "FETCH_ERROR":
      return produce(state, (draft) => {
        draft.loading = false;
        draft.error = "Data kon niet geladen worden, neem contact op met de beheerder.";
      });
  }
};
